// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"4d1853ea376f2b93bb33","883":"17675558b80063043c40"}[chunkId] + ".js";
};